import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {
    SellableReportSelectionData
} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";
import {
    EmployeeReportSelectionData
} from "../../../employee/employee/controls/employee-report-selection-control.component";

export class DetailedSalesReportData extends ReportData<DetailedSalesReportData> {
    @collection() groupBy: string[] = ["none"];
    @field reportType: string = "SIMPLE";
    @field saletype: string = "All";
    @field receiptno: string = "";
    @field invoiceNo: boolean = false;
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
}
